import styled from 'styled-components';

const ProductStyle = styled.div`
	--productMarginTop: var(--sp10x);
	--mainContainerMarginTop: var(--sp8x);

	--leftWrapperWidth: 48.82%;
	--wrapperDistance: var(--sp6x);

	--btnDistance: var(--sp8x);

	--absoluteBtnTop: 20vw;

	margin-top: var(--productMarginTop);

	overflow: hidden;

	.main-content-container {
		margin-top: var(--mainContainerMarginTop);
		display: flex;
		flex-wrap: wrap;
		gap: var(--wrapperDistance);

		/* transform: translate3d(40%, 0, 0);
		opacity: 0.9;
		transition: all 0.2s ease-out; */
	}

	.left-wrapper {
		width: var(--leftWrapperWidth);
	}

	.right-wrapper {
		flex: 1;
	}

	.main-content-container {
		position: relative;
	}

	.absolute-button {
		position: absolute;
		top: var(--absoluteBtnTop);
		z-index: 12;

		&.left {
			right: calc(100% + var(--btnDistance));
		}

		&.right {
			left: calc(100% + var(--btnDistance));
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(
			props
		) => props.theme.mediaQuery.DesktopSizeS}) {
		--productMarginTop: var(--sp9x);
		--mainContainerMarginTop: var(--sp6x);

		--leftWrapperWidth: 48%;

		--btnDistance: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(
			props
		) => props.theme.mediaQuery.DesktopSizeXS}) {
		--productMarginTop: var(--sp8x);
		--mainContainerMarginTop: var(--sp5x);

		--leftWrapperWidth: 48%;
		--wrapperDistance: var(--sp5x);

		--btnDistance: var(--sp1x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(
			props
		) => props.theme.mediaQuery.TabletSize}) {
		--productMarginTop: var(--sp6x);
		--mainContainerMarginTop: var(--sp5x);

		--leftWrapperWidth: 48%;
		--wrapperDistance: var(--sp4x);

		--btnDistance: var(--sp0-5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSizeS}) {
		--productMarginTop: var(--sp6x);
		--mainContainerMarginTop: var(--sp4x);

		--leftWrapperWidth: 100%;
		--wrapperDistance: 0;

		--btnDistance: var(--sp0-5x);

		--absoluteBtnTop: 45vw;

		.main-content-container {
			margin-top: unset;

			.right-wrapper {
				width: 100%;
				margin-top: var(--sp3x);
			}
		}

		.top-bar-wrapper {
			display: none;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--productMarginTop: var(--sp4x);
		--mainContainerMarginTop: var(--sp4x);

		--leftWrapperWidth: 100%;
		--wrapperDistance: 0;

		--btnDistance: -5%;

		--absoluteBtnTop: 45vw;

		.main-content-container {
			margin-top: unset;

			.right-wrapper {
				width: 100%;
				margin-top: var(--sp3x);
			}
		}

		.top-bar-wrapper {
			display: none;
		}
	}
`;

export default ProductStyle;
